import type { SVGProps } from 'react';

const ReservedParking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M11 3.5V8.5M21 3.5V8.5M4.75 13.5H27.25M12.25 21L14.75 23.5L19.75 18.5M7.25 6H24.75C26.1307 6 27.25 7.11929 27.25 8.5V26C27.25 27.3807 26.1307 28.5 24.75 28.5H7.25C5.86929 28.5 4.75 27.3807 4.75 26V8.5C4.75 7.11929 5.86929 6 7.25 6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReservedParking;
